import React from 'react'
import { motion } from 'framer-motion'

import TATA from '../../../assets/TATA.png'
import AR from '../../../assets/AR.png'
import BOSCH from '../../../assets/BOSCH.png'
import BULL from '../../../assets/BULL.png'
import CNI from '../../../assets/CNI.png'
import CYIENT from '../../../assets/CYIENT.png'
import HCL from '../../../assets/HCL.png'
import CAPGEMHINDUJA_TECH from '../../../assets/HINDUJA TECH.png'
import IDC from '../../../assets/IDC.png'
import LT from '../../../assets/L&T.png'
import SATVEN from '../../../assets/SATVEN.png'
import TAFE from '../../../assets/TAFE.png'
import TECH_MAHINDRA from '../../../assets/TECH MAHINDRA.png'




const partners = [
    TATA, AR, BOSCH, BULL, CNI, CYIENT, HCL, CAPGEMHINDUJA_TECH, IDC, LT, SATVEN, TAFE, TECH_MAHINDRA,
    TATA, AR, BOSCH, BULL, CNI, CYIENT, HCL, CAPGEMHINDUJA_TECH, IDC, LT, SATVEN, TAFE, TECH_MAHINDRA
]

const scrollSpeed = 20 // lower is faster

const ScrollingRow = ({ logos, reverse = false }) => {
    const duplicated = [...logos, ...logos]

    return (
        <div className="overflow-hidden w-full">
            <motion.div
                className="flex gap-8 py-6"
                initial={{ x: 0 }}
                animate={{ x: reverse ? ['0%', '-50%'] : ['-50%', '0%'] }}
                transition={{ repeat: Infinity, duration: scrollSpeed, ease: 'linear' }}
                whileHover={{ scale: 1.02 }}
            >
                {duplicated.map((logo, i) => (
                    <div key={i} className="flex-shrink-0 px-2">
                        <img
                            src={logo}
                            alt="partner"
                            className="w-[140px] sm:w-[120px] h-[70px] object-contain"
                        />
                    </div>
                ))}
            </motion.div>
        </div>
    )
}

export const Partners = () => {
    const firstRow = partners.slice(0, 7)
    const secondRow = partners.slice(7, 14)

    return (
        <div>
            <section className="bg-white py-16 max-w-7xl mx-auto">
                <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-primary-600">
                    Learners in Leading Companies
                </h2>

                <div className="space-y-10">
                    <ScrollingRow logos={firstRow} reverse={false} />
                    <ScrollingRow logos={secondRow} reverse={true} />
                </div>

            </section>

        </div>
    )
}
